import { NgModule } from '@angular/core';
import { PeopleProfileComponent } from "./people-profile.component";
import { CommonModule } from '@angular/common';
import { PeopleProfileHeaderModule } from "../../components/people-profile-header/people-profile-header.module";
import { PeopleProfileSnapshotModule } from "../../components/people-profile-snapshot/people-profile-snapshot.module";
import { PeopleProfileReportsModule } from "../../components/people-profile-reports/people-profile-reports.module";
import { SendXrefButtonModule } from "src/app/components/send-xref-button/send-xref-button.module";
import { FooterModule } from 'src/app/components/footer/footer.module';
import { SortV2Module } from 'src/app/components/sort-v2/sort-v2.module';
import {
  EnhancedPeopleProfileSnapshotModule
} from "../../components/enhanced-people-profile-snapshot/enhanced-people-profile-snapshot.module";

@NgModule({
  declarations: [PeopleProfileComponent],
  imports: [
    CommonModule,
    PeopleProfileHeaderModule,
    PeopleProfileSnapshotModule,
    EnhancedPeopleProfileSnapshotModule,
    PeopleProfileReportsModule,
    SendXrefButtonModule,
    FooterModule,
    SortV2Module,
  ]
})
export class PeopleProfileModule { }
